import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private environment: EnvironmentService,
    private http: HttpClient,
  ) {}

  get = <T>(
    url: string,
    params?:
      | HttpParams
      | {
          [param: string]:
            | string
            | number
            | boolean
            | ReadonlyArray<string | number | boolean>;
        },
  ): Promise<T> => {
    return lastValueFrom(
      this.http.get<T>(`${this.environment.config.apiBaseUrl}${url}`, {
        params,
      }),
    );
  };

  put = <T>(url: string, payload?: any): Promise<T> => {
    return lastValueFrom(
      this.http.put<T>(`${this.environment.config.apiBaseUrl}${url}`, payload),
    );
  };

  delete = <T>(url: string): Promise<T> => {
    return lastValueFrom(
      this.http.delete<T>(`${this.environment.config.apiBaseUrl}${url}`),
    );
  };

  post = <T>(url: string, payload?: any): Promise<T> => {
    return lastValueFrom(
      this.http.post<T>(`${this.environment.config.apiBaseUrl}${url}`, payload),
    );
  };
}
